/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import UserSearchEnvelopeRequest from './UserSearchEnvelopeRequest';

/**
 * The ScheduledInvestmentProposalConflictsRequest model module.
 * @module model/ScheduledInvestmentProposalConflictsRequest
 * @version 1.0.0
 */
class ScheduledInvestmentProposalConflictsRequest {
    /**
     * Constructs a new <code>ScheduledInvestmentProposalConflictsRequest</code>.
     * @alias module:model/ScheduledInvestmentProposalConflictsRequest
     * @param proposalDate {Date} 予約したい日時。この日時と同じ暦日（JST）の予約を重複とみなす。
     */
    constructor(proposalDate) { 
        
        ScheduledInvestmentProposalConflictsRequest.initialize(this, proposalDate);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, proposalDate) { 
        obj['proposal_date'] = proposalDate;
    }

    /**
     * Constructs a <code>ScheduledInvestmentProposalConflictsRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ScheduledInvestmentProposalConflictsRequest} obj Optional instance to populate.
     * @return {module:model/ScheduledInvestmentProposalConflictsRequest} The populated <code>ScheduledInvestmentProposalConflictsRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ScheduledInvestmentProposalConflictsRequest();

            if (data.hasOwnProperty('target_type')) {
                obj['target_type'] = ApiClient.convertToType(data['target_type'], 'String');
            }
            if (data.hasOwnProperty('user_ids')) {
                obj['user_ids'] = ApiClient.convertToType(data['user_ids'], ['Number']);
            }
            if (data.hasOwnProperty('search')) {
                obj['search'] = UserSearchEnvelopeRequest.constructFromObject(data['search']);
            }
            if (data.hasOwnProperty('re_proposal')) {
                obj['re_proposal'] = ApiClient.convertToType(data['re_proposal'], 'Boolean');
            }
            if (data.hasOwnProperty('proposal_date')) {
                obj['proposal_date'] = ApiClient.convertToType(data['proposal_date'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ScheduledInvestmentProposalConflictsRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ScheduledInvestmentProposalConflictsRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ScheduledInvestmentProposalConflictsRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['target_type'] && !(typeof data['target_type'] === 'string' || data['target_type'] instanceof String)) {
            throw new Error("Expected the field `target_type` to be a primitive type in the JSON string but got " + data['target_type']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['user_ids'])) {
            throw new Error("Expected the field `user_ids` to be an array in the JSON data but got " + data['user_ids']);
        }
        // validate the optional field `search`
        if (data['search']) { // data not null
          UserSearchEnvelopeRequest.validateJSON(data['search']);
        }

        return true;
    }


}

ScheduledInvestmentProposalConflictsRequest.RequiredProperties = ["proposal_date"];

/**
 * 対象の指定方法。省略時は user_ids。user_ids と search は排他で、同時指定は 400 を返す。
 * @member {module:model/ScheduledInvestmentProposalConflictsRequest.TargetTypeEnum} target_type
 * @default 'user_ids'
 */
ScheduledInvestmentProposalConflictsRequest.prototype['target_type'] = 'user_ids';

/**
 * target_type=user_ids のとき使用。チェック対象のユーザー ID（最大 10000 件）
 * @member {Array.<Number>} user_ids
 */
ScheduledInvestmentProposalConflictsRequest.prototype['user_ids'] = undefined;

/**
 * @member {module:model/UserSearchEnvelopeRequest} search
 */
ScheduledInvestmentProposalConflictsRequest.prototype['search'] = undefined;

/**
 * target_type=search のときの母集団。false は未提案一覧（bulk_deliveries 相当）、 true は提案済み一覧（bulk_re_deliveries 相当）。target_type=user_ids のときは参照しない。
 * @member {Boolean} re_proposal
 * @default false
 */
ScheduledInvestmentProposalConflictsRequest.prototype['re_proposal'] = false;

/**
 * 予約したい日時。この日時と同じ暦日（JST）の予約を重複とみなす。
 * @member {Date} proposal_date
 */
ScheduledInvestmentProposalConflictsRequest.prototype['proposal_date'] = undefined;





/**
 * Allowed values for the <code>target_type</code> property.
 * @enum {String}
 * @readonly
 */
ScheduledInvestmentProposalConflictsRequest['TargetTypeEnum'] = {

    /**
     * value: "user_ids"
     * @const
     */
    "user_ids": "user_ids",

    /**
     * value: "search"
     * @const
     */
    "search": "search"
};



export default ScheduledInvestmentProposalConflictsRequest;

